/**
 * Created by ddxfc on 2017/8/1.
 */
/*
 * 注入配置向相关的变量
 */

export default function (injection, Vue) {
    const config = {
        errorCode: {
            ACCESS_TOKEN_EMPTY: 40000,
            ACCESS_TOKEN_EXPIRED: 40001,
            PERMISSION_DENIED: 50001,
            USER_NOT_FOUND: 50002,
            USER_NOT_SITE_USER: 50003,
            USER_EMAIL_USED: 50004,
            USER_IS_SITE_USER: 50005,
            CANNOT_DELETE_POST: 10001
        },
        errorText: {},
        getRootUrl () {
            if ('laravel' in window) {
                if ('app_url' in window.laravel) {
                    return window.laravel.app_url;
                }
            }
            return '';
        },
        webUrl: {
            loginPage: process.env.NODE_ENV === 'production' ? '/login' : '/login.html',
            registerPage: process.env.NODE_ENV === 'production' ? '/register' : '/register.html',
            appPage: process.env.NODE_ENV === 'production' ? '/usercenter/index' : '/index.html'
        },

        apiUrl: {
            captcha: 'captcha',
            attachments: 'api/attachments',
            getResult: 'api/results',
            isfav: 'frontuc/isfav',
            fav: 'frontuc/fav',
            unfav: 'frontuc/unfav',
            sxuser: 'sxauth/user',
            visitHistory: 'frontuc/pagevisit'
        },
        opts: {},
        constance: {},
        statusMap: {
            'draft': '未发布',
            'finished': '已结束',
            'paused': '已暂停',
            'unpublished': '未发布',
            'collecting': '收集中'
        },
        inputLimitMap: {
            numeric: '纯数字',
            email: '电子邮件',
            chinese: '纯中文',
            english: '纯英文',
            url: '网站',
            idcard: '身份证',
            mobile: '手机号码'
        },
        uploadLimitMap: {
            document: '文档类文件，后缀格式为doc(x) / xls(x) / ppt(x) / wps / pdf / txt',
            image: '图片类文件，后缀格式为jp(e)g / png / bmp / gif ',
            video: '视频类文件，后缀格式为wmv / rmvb / mp4 / avi / mkv ',
            audio: '音频类文件，后缀格式为mp3',
            archive: '压缩包类文件，后缀格式为rar / zip '
        }
    };

    Object.defineProperties(Vue.prototype, {
        $config: {
            get () {
                return config;
            }
        }
    });

    Object.defineProperties(injection, {
        config: {
            get () {
                return config;
            }
        }
    });
}
